import { render, staticRenderFns } from "./ModeloView.vue?vue&type=template&id=dda1ccee&"
import script from "./ModeloView.vue?vue&type=script&lang=js&"
export * from "./ModeloView.vue?vue&type=script&lang=js&"
import style0 from "./ModeloView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports